import basketball from "../assets/testimonials/basketball.jpg";
import tennis from "../assets/testimonials/tennis.jpg";
// import running from "../assets/testimonials/running-track.jpg";
// import turf from "../assets/testimonials/synthetic-turf.jpg";
// import badminton from "../assets/testimonials/badminton.jpg";

const testimonialsData = [
  {
    id: 1,

    image: tennis,

    project: "Tennis Court",

    location: "Telangana",

    surface: "Acrylic",

    rating: 5,

    review:
      "As a Competitive track and field athlete, having a high-quality surface to train on is essential. Quality Sports delivered exactly what i needed. Their track installation has excellent shock  absorption, providing a comfortable and injury-free training experience. ",

    name: "RAVI KUMAR",

    designation: "South Physical Head",

    company: "NIT Warangal",
  },

  {
    id: 2,

    image: basketball,

    project: "Basketball Court",

    location: "Hyderabad",

    surface: "Acrylic",

    rating: 5,

    review:
      "I've always been passionate about basketball, and having a top-notch court in my backyard was a dream come true. Quality Sports Surface made that dream a reality!. Their basketball court installation is flawless, offering fantastic grip and consistent ball bounce. Thank you, Quality Sports Surface!.",

    name: "GYANA PRASAD",

    designation: "Physical Head",

    company: "BITS Pilani Hyderabad",
  },

  // Add the remaining 3 testimonials...
];

export default testimonialsData;
